import { sendMiraklViewBeacon } from '@noths/polaris-client-mirakl-tracking/browser';

import { PUBLIC_API_BASE_PATH } from 'src/constants/environment';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getMiraklAdUnits, getMiraklViewEvent } from 'src/tracking/mirakl/getMiraklViewEvent';

/**
 * Posts the view for the listing page in the store to this app's own beacon route, which applies
 * the consent and robot rules and sends one impression per ad unit carried. Nothing is sent for a
 * page Mirakl has no identity for.
 *
 * `withImpressions: false` leaves the ad units out, for a view whose impressions have already
 * gone: the server sends them with the rendered page whatever the consent state, so the view
 * sent once consent is granted must not bill them a second time.
 */
export const sendMiraklListingViewBeacon = (
  state: ReduxApplicationState,
  { withImpressions = true }: { withImpressions?: boolean } = {},
): void => {
  const event = getMiraklViewEvent(state);

  if (event) {
    sendMiraklViewBeacon(PUBLIC_API_BASE_PATH, {
      ...event,
      adUnits: withImpressions ? getMiraklAdUnits(state) : [],
      referer: document.referrer,
      url: window.location.href,
    });
  }
};
